export default function parseToMs(
  hora: string | number | null | undefined,
  now = new Date()
): number {
  if (hora == null) return NaN;

  if (typeof hora === "number") return hora;

  const s = String(hora).trim();

  const hhmm = /^([01]?\d|2[0-3]):([0-5]\d)$/;
  const m1 = s.match(hhmm);
  if (m1) {
    const h = Number(m1[1]);
    const m = Number(m1[2]);
    const d = new Date(now);
    d.setHours(h, m, 0, 0);
    return d.getTime();
  }

  const ymdHms = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?$/;
  const m2 = s.match(ymdHms);
  if (m2) {
    const [_, Y, M, D, h, m, sec = "0"] = m2;
    const d = new Date(Number(Y), Number(M) - 1, Number(D), Number(h), Number(m), Number(sec), 0);
    return d.getTime();
  }

  const ms = Date.parse(s);
  return Number.isNaN(ms) ? NaN : ms;
}
